"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import type { SectionsLogoCarousel, Theme } from "../../../types";
import { CarouselButton } from "../../common/carousel-button";
import NextImage from "next/image";

export interface LogoCarouselSwiperProps {
  swiperClassName?: string;
  navClassName?: string;
  swiperSliderClassName?: string;
  logos: SectionsLogoCarousel["logos"];
}

function LogoCarouselSwiper({
  swiperClassName,
  navClassName,
  swiperSliderClassName,
  logos,
}: LogoCarouselSwiperProps) {
  const swiperId = "logos-carousel";

  return (
    <>
      <Swiper
        breakpoints={{
          0: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          720: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 32,
          },
        }}
        modules={[Navigation]}
        navigation={{
          prevEl: `.prev-carousel-${swiperId}`,
          nextEl: `.next-carousel-${swiperId}`,
        }}
        simulateTouch={false}
        slidesPerView={5}
        spaceBetween={0}
        loop={true}
        className={swiperClassName}
      >
        {logos.map((logo) => (
          <SwiperSlide
            key={`logo-${logo.id}`}
            className={swiperSliderClassName}
          >
            <NextImage
              src={logo.url}
              alt={logo.alternativeText || ""}
              className="object-center object-contain mx-auto h-full opacity-30"
              height={logo.height}
              width={logo.width}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <nav className={navClassName} id={swiperId}>
        <CarouselButton
          className={`prev-carousel-${swiperId} pointer-events-auto border-none bg-transparent`}
          startIcon="arrow-left"
        />
        <CarouselButton
          className={`next-carousel-${swiperId} pointer-events-auto border-none bg-transparent`}
          startIcon="arrow-right"
        />
      </nav>
    </>
  );
}

export default LogoCarouselSwiper;
